import { Component, OnInit } from "@angular/core";
import { VernostServiceService } from "../../../services/vernost-service.service";
import { FileUploader } from "ng2-file-upload";
import { BsDatepickerConfig } from "ngx-bootstrap/datepicker";

import { Loggerservice } from "../../../services/logger-service";
import { Router } from "@angular/router";


const URL = window["omsubconfig"].backOffice + "/images/upload";


@Component({
  selector: 'app-banner-new',
  templateUrl: './banner-new.component.html'
})
export class BannerNewComponent implements OnInit {
  datePickerConfig: Partial<BsDatepickerConfig>;
  rejectedBN = 0;
  searchlistBN: boolean = true;
  showList: boolean = false;
  nameExistBN: boolean = false;
  previousDataBN: any = [];
  offSubmitBN = false;
  minRemarkBN = false;

  aprvbtnBN = false;
  approveStatusBN;
  isApprovedBN = false;
  updateApproveBN = false;
  searchresult: boolean = false;

  bannerCodeMinLengthBN = false;
  bannerCodeExceedLengthBN = false;
  bannerCodeNotAlphaNumeric: boolean = false;
  viewTitle: string = "Content View";
  insertDataTitleBN: string = "Data Successfully Inserted";
  loader: any = false;
  checkGuest: boolean = false;
  checkMemberBN: boolean = false;
  checkBoth: boolean = false;

  screentitle: string = "Content Master";
  actionmode: string = "Seacrh";
  parent_table = "mst_page";
  parent_table_IDBN = "BANNER_ID";
  BANNER_TYPE = "BANNER_CODE";
  BANNER_PAGE_BN = "BANNER_PAGE";
  PAGE_SECTION = "PAGE_SECTION";
  // BANNER_CODE = "BANNER_CODE";
  BANNER_IMAGE = "BANNER_IMAGE";
  BANNER_TEXT = "BANNER_TEXT";
  LOGIN_BANNER_IMAGE_BN = "LOGIN_BANNER_IMAGE";
  LOGIN_BANNER_TEXT_BN = "LOGIN_BANNER_TEXT";
  PLATFORM = "PLATFORM";
  // APPLICABLE_FROM = "APPLICABLE_FROM";
  // APPLICABLE_TO = "APPLICABLE_TO";
  // IS_LOGIN = "IS_LOGIN";

  Parent_result_ID = "";
  APPROVAL_STATUS_BN = "APPROVAL_STATUS";
  dbFields = [
    this.BANNER_PAGE_BN,
    this.PAGE_SECTION,
    // this.BANNER_CODE,
    this.BANNER_IMAGE,
    this.BANNER_TEXT,
    this.LOGIN_BANNER_IMAGE_BN,
    this.LOGIN_BANNER_TEXT_BN,
    this.BANNER_TYPE,
    this.PLATFORM,
    "BANNER_HEADER"

    // this.APPLICABLE_FROM,
    // this.APPLICABLE_TO
    // this.IS_LOGIN
  ];
  dbFieldss = [
    this.BANNER_PAGE_BN,
    this.PAGE_SECTION,
    // this.BANNER_CODE,
    this.BANNER_IMAGE,
    this.BANNER_TEXT,
    this.LOGIN_BANNER_IMAGE_BN,
    this.LOGIN_BANNER_TEXT_BN,
    this.BANNER_TYPE,
    this.PLATFORM,
    // this.APPLICABLE_FROM,
    // this.APPLICABLE_TO,
    // this.IS_LOGIN,
    "STATUS",
    "BANNER_HEADER"
  ];

  platform: any = [
    { key: "A", value: "UBA", id: "1"},
    { key: "R", value: "UBR", id: "0"}
  ];
  JourneyType: any = [
    {id: "1", value: "One Way"},
    {id: "0", value: "Return"}
  ];
  TripType: any = [
    {id: "1", value: "Domestic"},
    {id: "0", value: "International"}
  ];
  bannerPages: any = [];
  pageSections: any = [];
  pageSectionsData: any = [];
  bannerPagesData: any = [];
  prevBannerPages: any = [];
  prevPageSections: any = [];
  searchitem = " ";
  searchColumnBN = " ";
  childtablesBN = [];
  filters = [];
  screen_details: any = [];
  search_details: any = [];
  serachtabledataBN: any = [];
  serachTableInfo: any = [];
  data: any = [];
  status: any = {};
  sortType = "";
  p: number = 1;

  APPROVAL_REMARKS_BN = "APPROVAL_REMARKS";
  APPROVAL_BY = "APPROVAL_BY";
  aprove_detailsBN: any = [];
  uidBN = "";
  aprovebtnBN: boolean = true;
  rejectbtnBN: boolean = true;
  roleIDBN = "";
  fidBN = "";
  RAC_VIEW_BN = "";
  RAC_ADD_BN = "";
  RAC_EDIT_BN = "";
  RAC_APROVE_BN = "";
  BANNER_IMG = "";
  LOGIN_BANNER_IMG = "";
  isBannerImageBN: boolean = false;
  isSearchWidget: boolean = false;
  editedData: any = "";
  editedData1: any = "";
  logineditedDataBN: any = "";
  bannerHeading: any = "";
  isLoginData: boolean = false;
  isNotLoginData: boolean = false;
  onImageUpload: boolean = false;
  sectionDisable: boolean = true;
  searchFiltering: boolean = false;
  displayDisable: boolean = true;
  constructor(
    private vernostService: VernostServiceService,
    private logService: Loggerservice,
    private router: Router
  ) {}

  public uploader: FileUploader = new FileUploader({
    url: URL,
    itemAlias: "photo"
  });
  ngOnInit() {
    this.uidBN = localStorage.getItem("uid");
    this.roleIDBN = localStorage.getItem("roleID");
    this.fidBN = localStorage.getItem("fid");
    if (this.uidBN == "" || this.uidBN == undefined) {
      this.router.navigate(["/login"]);
    }
    this.isBannerImageBN = true;
    this.isSearchWidget = false;
    var rollArrayBannerNew = {
      funId: this.fidBN,
      roleID: this.roleIDBN
    };

    this.vernostService.checkFunAccess(rollArrayBannerNew).subscribe(res => {
      this.RAC_VIEW_BN = JSON.stringify(res[0].addinfo[0].RAC_VIEW);
      this.RAC_ADD_BN = JSON.stringify(res[0].addinfo[0].RAC_ADD);
      this.RAC_EDIT_BN = JSON.stringify(res[0].addinfo[0].RAC_EDIT);
      this.RAC_APROVE_BN = JSON.stringify(res[0].addinfo[0].RAC_APROVE);
    });
    
    this.Parent_result_ID = "";
    this.screen_details = {
      platform: "",
      pageId: "",
      sectionId: "",
      formFactor: "",
      bannerAltImage: "",
      contentLink: "",
      isNewTab: "",
      position: "",
      isContentActive: "",
      bannerImage: "",
      contentHeading: "",
      contentSubHeading: "",
      journeyType: "",
      TripType: "",
    };
    this.search_details = {
      bannerPageId: "",
      sectionId: "",
      formFactor: "",
      journeyType: "",
      TripType: "",
      platform: "",
    };
    this.showList = false;
    this.uploader.onAfterAddingFile = file => {
      file.withCredentials = false;
    };
    this.uploader.onCompleteItem = (
      item: any,
      response: any,
      status: any,
      headers: any
    ) => {
      let prop = JSON.parse(response);
      if (this.isNotLoginData == true) {
        this.screen_details.BANNER_IMAGE = prop.fileName;
        this.BANNER_IMG = prop.fileName;
      }
      if (this.isLoginData == true) {
        this.screen_details.LOGIN_BANNER_IMAGE = prop.fileName;
        this.LOGIN_BANNER_IMG = prop.fileName;
      }
    };
    this.getBannerDetails();
    this.getBannerNames();
  }
  getBannerDetails() {
    this.vernostService.getBannerDetails('getBannerPage').subscribe(response => {
      this.bannerPages = this.bannerPagesData = response;
    })
  }
  getBannerNames(){
    this.vernostService.getBannerDetails('getSections').subscribe(response => {
      this.pageSections = this.pageSectionsData = Object.values(response);   
    }); 
  }
  getFileDetails(event, type) {
    this.screen_details.bannerImageFile = event.target.files;
    this.onImageUpload = true;
  }
  onChangePageInfo(value, type, arrayName) {
    if (value != "") {
      let data = [...this.bannerPagesData];
      if (type == "platform") {
        if (this[arrayName].TripType != "") {
          data = data.filter(e => e.isOneWay == this[arrayName].TripType); 
        }
        if (this[arrayName].journeyType != "") {
          data = data.filter(e => e.isDomestic == this[arrayName].journeyType);
        }
        this.bannerPages = data.filter(e => e.isEarn == value);
      } else if (type == "TripType") {
        if (this[arrayName].platform != "") {
          data = data.filter(e => e.isEarn == this[arrayName].platform);
        }
        if (this[arrayName].journeyType != "") {
          data = data.filter(e => e.isDomestic == this[arrayName].journeyType);
        }
        this.bannerPages = data.filter(e => e.isOneWay == value);
      } else if (type == "journeyType") {
        if (this[arrayName].platform != "") {
          data = data.filter(e => e.isEarn == this[arrayName].platform);
        }
        if (this[arrayName].TripType != "") {
          data = data.filter(e => e.isDomestic == this[arrayName].TripType); 
        }
        this.bannerPages = data.filter(e => e.isOneWay == value);
      }
    }
    else {
      this[arrayName].bannerPageId = "";
      this[arrayName].sectionId = "";
      // this[arrayName].formFactor = "";
      if (arrayName == "screen_details") {
        this[arrayName].pageId = "";
      }
      this.bannerPages = this.bannerPagesData;
    }
    if (this[arrayName].platform != "" && this[arrayName].journeyType != "" && this[arrayName].TripType !="") {
      this.displayDisable = false;
    } else {
      this.displayDisable = true;
    }
    console.log(this.bannerPages, 'bannerPages');
    this.sectionDisable = true;
  }
  onChangeHandler(value, key, isUpdate) {
    if (key != "bannerImageFile" && value != "") {
      this.screen_details[key] =  value;
    }
    if (isUpdate != "update" && key == "pageId") {
      let pageArray = this.bannerPages.filter(page => page.id == this.screen_details[key]);
      if (pageArray.length > 0) {
        this.screen_details.pageType =  pageArray[0].isEarn;
      }
      this.pageSections = this.pageSectionsData.filter(section => section.pageId == this.screen_details[key]);
      this.screen_details.isWeb = "";
    }
    if (isUpdate != "update" && key == "sectionId") {
      let sectionArray = this.pageSectionsData.filter(page => page.id == this.screen_details.sectionId);
      if (sectionArray.length > 0) {
        this.screen_details.isWeb = sectionArray[0].isWeb;
      }      
    }
    if (key == "journeyType" || key == "TripType" || key == "platform") {
      this.onChangePageInfo(value, key, 'screen_details');
    }
    if (key == "formFactor" || key == "pageId") {
      this.onChangePageSearch(value, key, 'screen_details', 'pageId')
    }
  }

  count1 = 0;
  count2 = 0;
  addForm() {
    this.rejectedBN = 0;
    document.getElementById("errs").innerHTML = "";
    this.nameExistBN = false;
    this.screen_details = {
      platform: "",
      pageId: "",
      sectionId: "",
      formFactor: "",
      bannerAltImage: "",
      contentLink: "",
      isNewTab: "",
      position: "",
      isContentActive: "",
      bannerImageFile: [],
      contentHeading: "",
      contentSubHeading: "",
      bannerImage: "",
      journeyType: "",
      TripType: "",
    };
    this.prevBannerPages = this.bannerPages;
    this.bannerPages = this.bannerPagesData;
    this.prevPageSections = this.pageSections
    this.pageSections = this.pageSectionsData;
    this.bannerCodeMinLengthBN = false;
    this.bannerCodeExceedLengthBN = false;
    this.bannerCodeNotAlphaNumeric = false;
    this.sectionDisable = this.displayDisable = true;
    this.BANNER_IMG = "";
    this.LOGIN_BANNER_IMG = "";
    this.Parent_result_ID = "";
    this.showList = false;
    this.nameExistBN = false;
    this.actionmode = "Add";
  }
  searchForm() {
    document.getElementById("errs").innerHTML = "";
    this.screen_details = {
      sectionName: "",
      bannerImage: "",
      contentSubHeading: "",
      contentHeading: "",
      formFactor: "",
      pageId: "",
      sectionId: "",
      platform: "",
      bannerAltImage: "",
      contentLink: "",
      isNewTab: "",
      position: "",
      isActive: "",
      contentId: "",
      imageName: "",
      isContentActive: ""
    };
    this.actionmode = "Search";
    this.loader = false;
    if (this.search_details.platform != "" && this.search_details.TripType != "" && this.screen_details.journeyType != "") {
      this.displayDisable = false;
      this.bannerPages = this.prevBannerPages;
    } else {
      this.displayDisable = true;
    }
    if (this.search_details.formFactor != "" && this.search_details.bannerPageId != "" ) {
      this.sectionDisable = false;
      this.pageSections = this.prevPageSections;
    } else {
      this.sectionDisable = true;
    }
  }

  showFormData(contentId, isEdit) {
    this.serachTableInfo = this.serachtabledataBN.filter(content => content.contentId == contentId);
    if(!isEdit) {
      this.showList = true;
      this.actionmode = "View";
    } else {
      this.updateApproveBN = true;
      this.showList = false;
      this.actionmode = "Edit";
      this.screen_details = {
        sectionName: this.serachTableInfo[0].sectionName,
        bannerImage: this.serachTableInfo[0].imageURL,
        contentSubHeading: this.serachTableInfo[0].contentSubHeading,
        contentHeading: this.serachTableInfo[0].contentHeading,
        TripType: this.serachTableInfo[0].isDomestic,
        pageId: this.serachTableInfo[0].pageId,
        sectionId: this.serachTableInfo[0].sectionId,
        platform: this.serachTableInfo[0].isEarn,
        bannerAltImage: this.serachTableInfo[0].altImage,
        contentLink: this.serachTableInfo[0].linkURL,
        isNewTab: this.serachTableInfo[0].isNewTab,
        position: this.serachTableInfo[0].position,
        isActive: this.serachTableInfo[0].isActive,
        contentId: this.serachTableInfo[0].contentId,
        imageName: this.serachTableInfo[0].imageURL,
        journeyType: this.serachTableInfo[0].isOneway,
        isContentActive: this.serachTableInfo[0].isActive,
        formFactor:this.serachTableInfo[0].isWeb,
      };
      let pages = [...this.bannerPagesData];
      let sections = [...this.pageSectionsData];
      pages = pages.filter(e => e.isEarn == `${this.screen_details.platform}`);
      pages = pages.filter(e => e.isDomestic == `${this.screen_details.TripType}`);
      pages = pages.filter(e => e.isOneWay == `${this.screen_details.journeyType}`); 
      sections = sections.filter(e => e.pageId == this.screen_details.pageId);
      sections = sections.filter(e => e.isWeb == this.screen_details.formFactor);
      this.bannerPages = pages;
      this.pageSections = sections;
      console.log(this.bannerPages);
      console.log(this.screen_details, 'this.screen_details');
    }
    this.sectionDisable = false;
    this.displayDisable = false;
    console.log(this.serachTableInfo, 'serachTableInfo');
  }
  onChangePageSearch(value, type, arrayName, key) {
    if (value != "") {
      let data = [...this.pageSectionsData];
      if (type == "display" || type == "pageId") {
        this[arrayName].sectionId = "";
        this.sectionDisable = false;
        if (this[arrayName].formFactor == "") {
          this.sectionDisable = true;
        } else {
          data = data.filter(e => e.isWeb == this[arrayName].formFactor);
        }
        this.pageSections = data.filter(e => e.pageId == value);
      } else if (type == "formFactor") {
        if (this[arrayName][key] != "") {
          data = data.filter(e => e.pageId == this[arrayName][key]);
        }
        this.pageSections = data.filter(e => e.isWeb == value);
        this.sectionDisable = false;
        if (this[arrayName][key] == "") {
          this.sectionDisable = true;
        } 
      }
    } else {
      this.sectionDisable = true;
    }
  }
  searchData() {
    this.searchlistBN = false;
    this.loader = true;
    let pageId = this.search_details.bannerPageId;
    let sectionId = this.search_details.sectionId;
    let formFactor = this.search_details.formFactor;
    let journeyType = this.search_details.journeyType
    let tripType = this.search_details.TripType;
    let platform = this.search_details.platform;
    if (pageId == "" && sectionId == "" && formFactor == "" && journeyType == "" && tripType == "" && platform == "") {
      this.loader = false;
      document.getElementById("errs").innerHTML = "Please select some criteria";
      this.searchresult = false;
    } else {
      this.vernostService.searchBanner({
        pageId,
        sectionId,
        formFactor,
        journeyType,
        tripType,
        platform
      }).subscribe(resp => {
        if (resp.length > 0) {
          this.loader = false;
          document.getElementById("errs").innerHTML = "";
          this.serachtabledataBN = resp;
          this.searchresult = true;
          this.logService.create_log_masters(
            "'Component Name':Banner Master,'Action':Srarch Record,'Modified by':" +
              localStorage.getItem("fname"),
            "info"
          );
        } else {
          this.loader = false;
          document.getElementById("errs").innerHTML = "No Record Found..";
          this.serachtabledataBN = [];
          this.searchresult = false;
          setTimeout(function () {
            document.getElementById("errs").innerHTML = "";
          }, 5000);
        }
      });
    }
  }
 bannerUpload(formData) {
    return new Promise((resolve, reject) => {
      this.vernostService.uploadBanner(formData).subscribe(response => {
        this.onImageUpload = false;
        resolve(response)
      })
    })
 }
  async submitData() {
    this.loader = true;
    let payload = {
      routeName: this.actionmode == 'Edit' ? 'updateContentDetails' : 'addContentDetails',
      sectionId: this.screen_details.sectionId,
      contentHeading: this.screen_details.contentHeading,
      contentSubHeading: this.screen_details.contentSubHeading,
      imageName: this.screen_details.bannerImage,
      altImage: this.screen_details.bannerAltImage,
      linkUrl: this.screen_details.contentLink,
      contentId: this.screen_details.contentId,
      isNewTab: this.screen_details.isNewTab,
      position: this.screen_details.position,
      isContentActive: this.screen_details.isContentActive,
    }
    console.log(this.screen_details, 'screen_details');
    if (this.onImageUpload) {
      const formData = new FormData();
      formData.append('photo' , this.screen_details.bannerImageFile[0]);
      let response = await this.bannerUpload(formData)
      payload.imageName = this.screen_details.bannerImage = response["fileName"];
    } 
    if (payload.contentHeading != "" && payload.contentSubHeading != "" && payload.altImage != "" && payload.linkUrl != "" && payload.isNewTab != "" && payload.position != "" && payload.isContentActive != "") {
      this.vernostService.postBannerDetails(payload).subscribe(response => {
        console.log(response['status'], "status");
        if (response['status']) {
          document.getElementById("errs").style.color = "#a94442";
          document.getElementById("errs").style.background = "#ebccd1";
          document.getElementById("errs").innerHTML = `Record ${this.actionmode == "Edit" ? 'updated' : 'inserted'} successfully`;
          this.serachTableInfo = response['data'];
          if (this.actionmode == "Edit" || this.search_details.bannerPageId != "" || this.search_details.sectionId != "") { 
            this.searchData()
          }
          this.showList = true;
          this.actionmode = "View";
          setTimeout(() => {
            document.getElementById("errs").innerHTML = "";
          }, 1000);
        } else {
          document.getElementById("errs").innerHTML =
              `Error: ${response['message']}`;
        }
      })
    } else {
      document.getElementById("errs").innerHTML = "Please fill all record";
    }
  }
  keyupHandler(e, key) {
    this.screen_details[key] = e;
  }
  url = window["omsubconfig"].fetchimageurl + "fetchimage?name=";
  getImage(val) {
    if (val == undefined) {
      return "../../assets/img/plain-white-background.jpg";
    } else {
      return this.url + val;
    }
  }
}